import React, { FC, useEffect, useState } from 'react';
import { Avatar, Dropdown } from 'flowbite-react';
import { FaBars, FaBell, FaToggleOff, FaToggleOn } from 'react-icons/fa';
import * as styles from './privateNavbar.styles';
import { Link, useNavigate } from 'react-router-dom';
import client from '../../api/client';
import showToast from '../CustomToast/toastHelper';

const PrivateNavbar: FC<any> = ({ toggleSidebar, userDetails, setUser }) => {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            const response = await client.post('/subsidiary/dashboard/logout');
            showToast(response.data.message, 'success');
            setUser(null);
            sessionStorage.removeItem("accessToken");

            navigate("/login");
        } catch (err: any) {

            const message = err?.response?.data?.message;
            showToast(message, 'error');
        }

    };

    const [environment, setEnvironment] = useState<string>(''); // Initialize environment state
    const fetchEnvironment = () => {
        if (userDetails.envronmentDetail.id === 1) {
            setEnvironment('Test');
        } else {
            setEnvironment('Live');
        }
    };

    useEffect(() => {
        fetchEnvironment();
    }, [userDetails.envronmentDetail]);
    const handleToggle = async (newEnvironmentId: number) => {
        try {
            const apiUrl = '/subsidiary/dashboard/environment/toggle';
            const payload = {
                environmentId: newEnvironmentId,
                setDefault: true,
            };
            const response = await client.patch(apiUrl, payload);

            const message = response?.data?.message;
            showToast(message, "success");

            setEnvironment(newEnvironmentId === 1 ? 'Test' : 'Live');
            window.location.reload()
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    };

    const { user } = userDetails;

    return (
        <div className={styles.container}>
            <button className="text-gray-700 md:hidden" onClick={toggleSidebar}>
                <FaBars />
            </button>
            <div className={styles.content}>
                <div className="flex items-center gap-2">
                    <p className={environment === "Test" ? 'text-custom-button-green' : ''}>Test</p>
                    {environment === "Live" ? (
                        <FaToggleOn size={25} onClick={() => handleToggle(1)} />
                    ) : (
                        <FaToggleOff size={25} onClick={() => handleToggle(2)} />
                    )}
                    <p className={environment === "Live" ? 'text-custom-button-green' : ''}>Live</p>
                </div>
                <FaBell />
                <Avatar rounded size="sm" />
                <div className="flex gap-2">
                    <Dropdown
                        label={<p className="text-sm">{`${user.firstName} ${user.lastName}`}</p>}
                        inline
                    >
                        <Dropdown.Header>
                            <p>{`${user.firstName} ${user.lastName}`}</p>
                            <p>{`${user.emailAddress}`}</p>
                        </Dropdown.Header>
                        <Link to="/"><Dropdown.Item>Dashboard</Dropdown.Item></Link>
                        <Link to="/settings"><Dropdown.Item>Settings</Dropdown.Item></Link>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={handleLogout}>Sign out</Dropdown.Item>
                    </Dropdown>
                </div>
            </div>
        </div>
    );
};

export default PrivateNavbar;
